













import { NumberType } from 'expangine-runtime';
import { NumberTextBoxOptions } from './NumberTextBoxTypes';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<NumberType, NumberTextBoxOptions, number | string>([Number, String]).extend({
  name: 'NumberTextBox',
  computed: {
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
  methods: {
    fix() {
      const { whole } = this.type.options;
      if (whole) {
        const asInt = Math.floor(this.value as number);
        if (asInt !== this.computedValue) {
          this.computedValue = asInt;
        }
      }
    },
  },
});
